import {usePrevious} from 'ahooks';
import {RefObject, useEffect, useRef} from 'react';

/**
 * @description: 事件监听的hook
 * @param name: 事件名称
 * @param callback: 回调函数
 */
// const useEventListener = (name: string, callback: EventListenerOrEventListenerObject, target?: (() => Window | Document) | Element) => {
//     const previous = usePrevious(target);
//     // 不能直接在这里把默认值写成window, 否则会触发SSR报错
//     useEffect(() => {
//         const listener = callback;
//         // 不保存一次可能会销毁不掉?
//         const previousTarget = typeof previous === 'function' ? previous() : previous;
//         const eventTarget = typeof target === 'function' ? target() : target;
//         if (previousTarget) {
//             previousTarget.removeEventListener(name, listener);
//         }
//         if (eventTarget) {
//             eventTarget.addEventListener(name, listener);
//             return () => {
//                 eventTarget.removeEventListener(name, listener);
//             };
//         }
//     }, [target]);
// };
const useEventListener = (name: string, callback: EventListenerOrEventListenerObject, target: (() => Window | Document) | Element | RefObject<any>) => {
    // const hasListen = useRef(false);
    // 不能直接在这里把默认值写成window, 否则会触发SSR报错
    useEffect(() => {
        if (!target) {
            return;
        }
        // 不保存一次可能会销毁不掉?
        let eventTarget: Element | Window | Document;
        if (typeof target === 'function') {
            eventTarget = target();
        }
        else if ('current' in target) {
            eventTarget = target.current;
        }
        else {
            eventTarget = target;
        }


        if (eventTarget) {
            // hasListen.current = true;
            const listener = callback;
            eventTarget.addEventListener(name, listener);
            return () => {
                eventTarget.removeEventListener(name, listener);
            };
        }
    }, [target, callback]);
};

export default useEventListener;
